import * as React from "react";
import { Box, Typography } from "@mui/material"; 
import { useTheme } from "@mui/material/styles";
import { getRuntimeAppProfile } from "../../runtime/appProfile";

export function PlanyBrandMark() {
  const theme = useTheme();
  const chrome = theme.customChrome || {};
  const resolveBrand = React.useCallback(() => {
    const profile = getRuntimeAppProfile();
    return profile.verticalId === "booking"
      ? { name: "Timely365", label: "Booking" }
      : { name: "Plany365", label: "Care" };
  }, []);
  const [brand, setBrand] = React.useState(resolveBrand);

  // refresh when storage changes (cross-tab) or we dispatch our custom event (same-tab)
  React.useEffect(() => {
    const refresh = () => setBrand(resolveBrand());
    window.addEventListener("storage", refresh);
    window.addEventListener("vertical:changed", refresh);
    window.addEventListener("focus", refresh);
    return () => {
      window.removeEventListener("storage", refresh);
      window.removeEventListener("vertical:changed", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, [resolveBrand]);

  React.useEffect(() => {
    setBrand(resolveBrand());
  }, [resolveBrand]);

  return (
    <Typography
      component="span"
      sx={{
        fontSize: "0.9rem",
        fontWeight: 400,
        fontFamily: "Roboto, Arial, sans-serif",
        color: chrome.brandText || theme.palette.text.primary,
        textDecoration: "none",
        letterSpacing: "1px",
        lineHeight: 1.2,
        whiteSpace: "nowrap",
      }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "flex-end", // puts the bottom word to the right corner under Plany365
          lineHeight: 1,
        }}
      >
        <Box component="span" sx={{ fontSize: "1em", fontWeight: 600 }}>
          {brand.name}
        </Box>
        <Box component="span" sx={{ fontSize: "0.75em", mt: "0.1em" }}>
          {brand.label}
        </Box>
      </Box>
    </Typography>
  );
}
